import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const MediumCountIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-mediumCount"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M54 4H16a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4h38a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4M16 6h38a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H16a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M22.98 16.868q-.001 1.575.197 2.164.195.59.66.59.47 0 .663-.609.193-.61.194-2.145 0-1.543-.197-2.162t-.66-.619-.66.597q-.198.596-.197 2.184m4.209 0q0 2.463-.826 3.608-.825 1.146-2.526 1.146-1.664 0-2.508-1.196-.844-1.197-.844-3.558-.001-2.475.826-3.63.825-1.156 2.526-1.157 1.658 0 2.503 1.203.85 1.203.849 3.584m6.79 0q0 1.575.197 2.164t.66.59q.47 0 .665-.609.192-.61.193-2.145-.001-1.543-.197-2.162-.198-.619-.66-.619-.465 0-.66.597-.198.596-.197 2.184m4.209 0q0 2.463-.825 3.608-.826 1.146-2.527 1.146-1.664 0-2.508-1.196-.843-1.197-.844-3.558 0-2.475.825-3.63.825-1.156 2.526-1.157 1.657 0 2.505 1.203t.847 3.584"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M53.5 7h-37A1.5 1.5 0 0 0 15 8.5v17a1.5 1.5 0 0 0 1.5 1.5h37a1.5 1.5 0 0 0 1.5-1.5v-17A1.5 1.5 0 0 0 53.5 7m-37 1h37a.5.5 0 0 1 .5.5v17a.5.5 0 0 1-.5.5h-37a.5.5 0 0 1-.5-.5v-17a.5.5 0 0 1 .5-.5"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M46.651 8q.066.234.067.503a.97.97 0 0 1-.304.717 1 1 0 0 1-.717.299q-.456 0-.68-.308-.22-.308-.22-.829c0-.148.022-.262.042-.382h-2.444c-.012.137-.03.268-.03.414q0 1.415.68 2.222.678.806 1.883.806.521 0 .871-.108.349-.108.59-.312.24-.202.49-.66h.075q-.064 1.201-.794 1.756t-2.075.555q-.548 0-1.092-.102v1.988q.443.063 1.295.063 2.582 0 3.758-1.219 1.173-1.219 1.173-3.941c0-.54-.06-1.018-.155-1.462zm-1.347 13.078a.82.82 0 0 1 .546-.187q.31 0 .533.184a.6.6 0 0 1 .222.488.8.8 0 0 1-.165.49q-.166.214-.615.475-.744-.418-.744-.965 0-.298.223-.485m-1.155 2.567q-.914.464-1.302 1.032c-.25.365-.371.81-.38 1.323h2.3c0-.018-.01-.032-.01-.05a1 1 0 0 1 .245-.639q.245-.3.81-.599.628.374.873.676.244.3.244.612h2.299a2.1 2.1 0 0 0-.417-1.228q-.422-.58-1.45-1.165.83-.412 1.215-.967.384-.555.384-1.292 0-1.086-.815-1.676-.816-.59-2.282-.59-1.468 0-2.298.593-.832.594-.832 1.66 0 .679.34 1.247t1.076 1.063"
        />
      </g>
    </Icon>
  )
}
